export const formatter = (num: number) => {
	if (num === 0) return 0
	return new Intl.NumberFormat('ru', { style: 'decimal' }).format(num)
}
